<script lang="ts">
	import { RoutedButton } from '../components';
	import { t } from '../i18n';
</script>

<div class="flex min-h-[60vh] flex-col items-center justify-center text-center">
	<div class="mb-4 text-8xl font-bold text-gray-200 dark:text-gray-700">404</div>
	<h1 class="mb-2 text-2xl font-semibold text-gray-900 dark:text-white">{$t("Page Not Found")}</h1>
	<p class="mb-6 max-w-md text-gray-500 dark:text-gray-400">
		{$t("The page you're looking for doesn't exist or has been moved.")}
	</p>
	<RoutedButton href="/">
		<i class="fa-solid fa-house mr-2"></i>
		{$t("Go to Dashboard")}
	</RoutedButton>
</div>
